export default "__VITE_ASSET__BV1tf24G__"